export default __webpack_public_path__ + "static/media/mlb-bg.3bb7a4e6.jpg";